import { useRef } from 'react';
import classnames from 'classnames';

import ButtonUI from 'components/atoms/ButtonUI';
import SoundBtn from 'components/atoms/SoundBtn';

import { useUserData } from 'models/user';
import { useAuth } from 'models/auth';
import { useFadeIn } from 'utils/hooks';
import { useModal } from 'models/modal';
import { useSoundOn } from 'models/mainSite';

import { characterData, themeData } from 'data/character';

import type { CharacterType, ThemeType } from 'data/character';

import bag from 'images/icons/bag.png';
import coupon from 'images/icons/coupon.png';
import clothesIcon from 'images/icons/clothes.png';

import styles from './index.css';

export interface UserControlBottomLayoutProp {
    className?: string;
    characterType: CharacterType | ThemeType;
    onOpenBag?: () => void;
    onOpenTicket?: () => void;
    onOpenTheme?: () => void;
    openProfile?: () => void;
    visitor?: boolean;
    newTicket?: boolean;
}

export const UserControlBottomLayout: React.FC<UserControlBottomLayoutProp> = ({
    className,
    characterType,
    onOpenBag = () => {},
    onOpenTicket = () => {},
    onOpenTheme = () => {},
    openProfile = () => {},
    visitor = false,
    newTicket = false,
}) => {
    const ref = useRef(null);
    const [soundOn] = useSoundOn();

    useFadeIn([{ ref }]);

    return (
        <div
            ref={ref}
            className={classnames(styles.userControlBottom, visitor && styles.visitor, className)}
        >
            <div className={styles.avatar} onClick={openProfile}>
                <img
                    src={
                        characterType < 2800
                            ? characterData[characterType].avatar
                            : themeData[characterType].avatar
                    }
                    alt={`character${characterData[characterType]}.id`}
                />
            </div>
            <div className={styles.actions}>
                <ButtonUI className={styles.button} icon={bag} text="背包" onClick={onOpenBag} />
                <ButtonUI
                    className={styles.button}
                    icon={coupon}
                    text="扭蛋券"
                    onClick={onOpenTicket}
                    notification={newTicket}
                />
                <ButtonUI
                    className={styles.button}
                    icon={clothesIcon}
                    text="造型"
                    onClick={onOpenTheme}
                />
            </div>
            <SoundBtn className={styles.soundBtn} soundOn={soundOn} />
        </div>
    );
};

export interface UserControlBottomProp {
    className?: string;
}

const UserControlBottom: React.FC<UserControlBottomProp> = ({ className }) => {
    const [{ loginType }] = useAuth();
    const [{ characterType, activeTheme, availableTicketCount }] = useUserData();
    const [, { openModal }] = useModal();

    return (
        <UserControlBottomLayout
            className={className}
            visitor={loginType !== 'facebook'}
            characterType={activeTheme > 2800 ? activeTheme : characterType}
            newTicket={availableTicketCount > 0}
            onOpenBag={() => {
                if (loginType === 'facebook') {
                    openModal({ type: 'userBag' });
                } else {
                    openModal({ type: 'needLogin' });
                }
            }}
            onOpenTicket={() => {
                if (loginType === 'facebook') {
                    openModal({ type: 'userTicket' });
                } else {
                    openModal({ type: 'needLogin' });
                }
            }}
            onOpenTheme={() => {
                if (loginType === 'facebook') {
                    openModal({ type: 'userCloset' });
                } else {
                    openModal({ type: 'needLogin' });
                }
            }}
            openProfile={() => {
                if (loginType === 'facebook') {
                    openModal({ type: 'profile' });
                } else {
                    openModal({ type: 'needLogin' });
                }
            }}
        />
    );
};

export default UserControlBottom;
